export function setCountries(state, countries) {
  state.countries = countries
}


// WEBPACK FOOTER //
// ./src/modules/countries/mutations.js